<script setup lang="ts">
import ToastNotification from '@/components/ToastNotification.vue'
import type { Notification } from '@/composables/useToast'
import { useVersionCheck } from '@/composables/useVersionCheck'
import { useEventBus, whenever } from '@vueuse/core'
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'

// If you try using PrimeVue's useToast composable outside of a component,
// it will fail with 'No PrimeVue Toast provided' error.
// See the original issue and the workaround here:
// https://github.com/primefaces/primevue/issues/6403#issuecomment-2363381833

const bus = useEventBus<Notification>('notification')
const toaster = useToast()
const { hasUpdate } = useVersionCheck()

bus.on((message) => {
  toaster.add(message)
})

whenever(hasUpdate, () => {
  toaster.add({
    severity: 'info',
    summary: 'Update available',
    detail: 'A new version of Nomic HQ is available. Please refresh the page to update.'
  })
})
</script>

<template>
  <!-- One stack, one corner. Every notification renders through
       ToastNotification, because a notification that offers somewhere to go
       needs a body the default Toast has nowhere to put a link in — and giving
       the linked ones their own Toast would put a second stack in a second
       corner, which is not where this application's notifications appear. -->
  <Toast position="bottom-right">
    <template #message="{ message }">
      <ToastNotification :message="message" />
    </template>
  </Toast>
</template>
